<template>
    <div :class="isAfert ? 'entity-compare-after' : ''">
        <div>
            <div class="tab-heading">
                <h2>{{ t('pharmacy-groups::stepper.title.main_details') }}</h2>
            </div>
            <div class="notification-field group_name">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.group_name') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.group_name }}</div>
            </div>
            <div class="notification-field is_registered">
                <label class="label">{{ t('pharmacy-groups::form.label.is_registered') }}</label>
                <div class="value">{{ getStatus(store.is_registered) }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('pharmacy-groups::form.title.address') }}</h3>
            </div>
            <div class="notification-field address">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.address') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.address }}</div>
            </div>
            <div class="notification-field post_code">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.post_code') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.post_code }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('pharmacy-groups::form.title.contact_details') }}</h3>
            </div>
            <div class="notification-field phone">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.phone }}</div>
            </div>
            <div class="notification-field fax">
                <label class="label">{{ t('pharmacy-groups::form.label.fax') }}</label>
                <div class="value">{{ store.fax }}</div>
            </div>
            <div class="notification-field email">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.email') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.email }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('pharmacy-groups::stepper.title.chief_pharmacist') }}</h2>
            </div>
            <div class="notification-field chief_pharmacist_name">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.chief_pharmacist_name') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.chief_pharmacist_name }}</div>
            </div>
            <div class="notification-field chief_pharmacist_phone">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.chief_pharmacist_phone') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.chief_pharmacist_phone }}</div>
            </div>
            <div class="notification-field chief_pharmacist_fax">
                <label class="label">{{ t('pharmacy-groups::form.label.chief_pharmacist_fax') }}</label>
                <div class="value">{{ store.chief_pharmacist_fax }}</div>
            </div>
            <div class="notification-field chief_pharmacist_email">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.chief_pharmacist_email') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.chief_pharmacist_email }}</div>
            </div>
            <div class="notification-field chief_pharmacist_rpsgb_number">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.chief_pharmacist_rpsgb_number') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.chief_pharmacist_rpsgb_number }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('pharmacy-groups::stepper.title.technician_details') }}</h2>
            </div>
            <div class="notification-field technician_name">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.technician_name') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.technician_name }}</div>
            </div>
            <div class="notification-field technician_phone">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.technician_phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.technician_phone }}</div>
            </div>
            <div class="notification-field technician_fax">
                <label class="label">{{ t('pharmacy-groups::form.label.technician_fax') }} </label>
                <div class="value">{{ store.technician_fax }}</div>
            </div>
            <div class="notification-field technician_email">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.technician_email') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.technician_email }}</div>
            </div>
            <div class="notification-field technician_rpsgb_number">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.technician_rpsgb_number') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.technician_rpsgb_number }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('pharmacy-groups::stepper.title.out_hours') }}</h2>
            </div>
            <div class="notification-field out_of_hours_contact_name">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.out_of_hours_contact_name') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.out_of_hours_contact_name }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_phone">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.out_of_hours_contact_phone') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.out_of_hours_contact_phone }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_fax">
                <label class="label">{{ t('pharmacy-groups::form.label.out_of_hours_contact_fax') }}</label>
                <div class="value">{{ store.out_of_hours_contact_fax }}</div>
            </div>
            <div class="notification-field out_of_hours_contact_email">
                <label class="label"
                    >{{ t('pharmacy-groups::form.label.out_of_hours_contact_email') }}
                    {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.out_of_hours_contact_email }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('pharmacy-groups::stepper.title.pharmacy_sites') }}</h2>
            </div>
            <div class="notification-field blood_result_providers">
                <label class="label">{{ t('pharmacy-groups::form.label.blood_providers') }}</label>
                <div class="value">{{ getSelectItem(selectedPharmacySites, store.pharmacy_sites) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificationPharmacyGroupsApprovalRequestForm',
    components: {},
    props: {
        store: {
            type: Object,
            required: true,
        },
        isAfert: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        updatedProps() {
            return this.$store.state.notification_pharmacy_group.updatedProps.map((x) => x.replace('.', '-'));
        },
        selectedPharmacySites() {
            return this.$store.state.pharmacy_groups.pharmacy_group.pharmacy_sites;
        },
    },
    watch: {
        updatedProps() {
            this.setActiveItems();
        },
    },
    mounted() {
        this.setActiveItems();
    },
    created() {},
    methods: {
        getStatus(status) {
            return status ? 'True' : 'False';
        },
        getSelectItem(items, value) {
            return items.find((x) => x.value === value) ? items.find((x) => x.value === value).text : null;
        },
        setActiveItems() {
            if (!this.updatedProps.length) {
                return;
            }
            this.updatedProps.forEach((props) => {
                const field = this.$el.querySelector(`.${props}`);
                // console.warn('props', field ? field : props);
                if (field) {
                    field.classList.add('updated');
                }
            });
        },
    },
};
</script>
